"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _knownAxis = _interopRequireDefault(require("../video-player/shapes/known-axis.shape"));

const AspectRatioBox = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    children,
    width,
    height,
    knownAxis,
    className
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["children", "width", "height", "knownAxis", "className"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "".concat(className, " aspect-ratio-box ").concat(knownAxis === 'width' ? 'aspect-ratio-box--known-width' : 'aspect-ratio-box--known-height'),
    ref: ref
  }, otherProps), /*#__PURE__*/_react.default.createElement("canvas", {
    width: width,
    height: height
  }), children);
});

AspectRatioBox.propTypes = {
  children: _propTypes.default.node,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  knownAxis: _knownAxis.default,
  className: _propTypes.default.string
};
const WIDE_VIDEO_RATIO = {
  width: 16,
  height: 9
};
AspectRatioBox.defaultProps = {
  children: null,
  width: WIDE_VIDEO_RATIO.width,
  height: WIDE_VIDEO_RATIO.height,
  knownAxis: 'width',
  className: ''
};
var _default = AspectRatioBox;
exports.default = _default;